import { routes } from '../../routes';

const base = `/${routes.START}`;

export type GuidelineNavigationItem = {
    key: string;
    label: string;
    meta: string;
    path: string;
};

export type GuidelineNavigationGroup = {
    group: string;
    items: GuidelineNavigationItem[];
};

export const guidelineNavigationGroups: GuidelineNavigationGroup[] = [
    {
        group: 'Guidelines',
        items: [
            {
                key: 'Responsiveness',
                label: 'Responsiveness',
                meta: 'responsiveness platforms breakpoints col grid flex',
                path: `${base}/responsiveness`,
            },
            {
                key: 'State in URL',
                label: 'State in URL',
                meta: 'state-in-url deep link url',
                path: `${base}/guidelines/state-in-url`,
            },
            {
                key: 'Google Analytics',
                label: 'Google Analytics',
                meta: 'google analytics tracking analytics overlay gettrackingattributes autotrackingkey ga',
                path: `${base}/guidelines/google-analytics`,
            },
            {
                key: 'Color combinations',
                label: 'Color combinations',
                meta: 'color-combinations',
                path: `${base}/guidelines/color-combinations`,
            },
            {
                key: 'Custom CSS',
                label: 'Custom CSS',
                meta: 'custom-css',
                path: `${base}/guidelines/custom-css`,
            },
            {
                key: 'Custom icons',
                label: 'Custom icons',
                meta: 'custom-icon',
                path: `${base}/guidelines/custom-icon`,
            },
            {
                key: 'Button guidelines',
                label: 'Button guidelines',
                meta: 'button buttons guideline style variant layout primary secondary block hover scale',
                path: `${base}/guidelines/buttons`,
            },
            {
                key: 'Interaction and feedback',
                label: 'Interaction and feedback',
                meta: 'interaction feedback loading validation notification confirmation errors states',
                path: `${base}/guidelines/interaction-feedback`,
            },
            {
                key: 'Navigation and information architecture',
                label: 'Navigation and information architecture',
                meta: 'navigation information architecture application layout subnavigation tabs sidebar asset tree',
                path: `${base}/guidelines/navigation-information-architecture`,
            },
            {
                key: 'Motion and animation',
                label: 'Motion and animation',
                meta: 'motion animation transition micro interaction fade collapse enter exit reduced motion',
                path: `${base}/guidelines/motion`,
            },
            {
                key: 'Prototyping and UX testing',
                label: 'Prototyping and UX testing',
                meta: 'prototype prototyping ux testing wireframes theme ai assistant mcp server codex',
                path: `${base}/guidelines/prototyping-ux-testing`,
            },
            {
                key: 'UIKIT and Figma',
                label: 'UIKIT and Figma',
                meta: 'uikit figma playground export import plugin design editable layers',
                path: `${base}/guidelines/uikit-and-figma`,
            },
            {
                key: 'iframe',
                label: 'Iframes',
                meta: 'iframe',
                path: `${base}/guidelines/iframe`,
            },
            {
                key: 'Loading',
                label: 'Loading',
                meta: 'spinner',
                path: `${base}/guidelines/spinner`,
            },
            {
                key: 'Email',
                label: 'HTML emails',
                meta: 'email',
                path: `${base}/guidelines/email`,
            },
            {
                key: 'Print CSS',
                label: 'Print CSS',
                meta: 'print-css',
                path: `${base}/guidelines/print-css`,
            },
            {
                key: 'Obfuscate pii sensible',
                label: 'Obfuscate data',
                meta: 'obfuscate-data',
                path: `${base}/guidelines/obfuscate-data`,
            },
            {
                key: 'Formatting guide',
                label: 'Formatting guide',
                meta: 'formatting date number dateformat datetime time format',
                path: `${base}/guidelines/formatting`,
            },
            {
                key: 'Writing style guide',
                label: 'Writing style guide',
                meta: 'writing',
                path: `${base}/guidelines/writing`,
            },
        ],
    },
    {
        group: 'Working with AI',
        items: [
            {
                key: 'UIKIT MCP Server',
                label: 'UIKIT MCP Server',
                meta: 'mcp server codex skill ai assistant',
                path: `${base}/guidelines/uikit-mcp-server`,
            },
            {
                key: 'Agent skill',
                label: 'Agent skill',
                meta: 'agent skill codex rio-uikit ai assistant rules quality gates mcp server',
                path: `${base}/guidelines/agent-skill`,
            },
            {
                key: 'Prototyping with AI',
                label: 'Prototyping with AI',
                meta: 'prototype prototyping codex ai assistant mcp server skill wireframes',
                path: `${base}/guidelines/prototyping-with-ai`,
            },
        ],
    },
];

export const guidelineNavigationItems = guidelineNavigationGroups.flatMap(group => group.items);

export const getAdjacentGuidelineNavigationItems = (pathname: string) => {
    const currentIndex = guidelineNavigationItems.findIndex(item => item.path === pathname);

    if (currentIndex === -1) {
        return;
    }

    return {
        previous: guidelineNavigationItems[currentIndex - 1],
        next: guidelineNavigationItems[currentIndex + 1],
    };
};
